import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  error: null,
  isLoading: false,
  allAlertingTollPolicies: [],
  allAlertingTolls: [],
  toolMapping: [],
  toolProjects: [],
  toolInfo: [],
  toolFields: [],
  companyServicesList: [],
  toggleModal: false,
  customerToolMapping: [],
};

const AlertPolicySlice = createSlice({
  name: 'alertPolicySlice',
  initialState,
  reducers: {
    start: (state) => {
      state.isLoading = true;
      state.error = null;
    },
    setReducerError: (state, action) => {
      state.error = action.payload;
      state.isLoading = false;
    },
    setAllAlertingToolPolicies: (state, action) => {
      state.allAlertingTollPolicies = action.payload;
      state.isLoading = false;
    },
    setAllAlertingTools: (state, action) => {
      state.allAlertingTolls = action.payload;
      state.isLoading = false;
    },
    setToolMappingData: (state, action) => {
      state.toolMapping = action.payload;
      state.isLoading = false;
    },
    setToolProjectsData: (state, action) => {
      state.toolProjects = action.payload;
      state.isLoading = false;
    },
    getAllToolInfo: (state, action) => {
      state.toolInfo = action.payload;
      state.isLoading = false;
    },
    setToolFields: (state, action) => {
      state.toolFields = action.payload;
      state.isLoading = false;
    },
    setCompanyServicesList: (state, action) => {
      state.companyServicesList = action.payload;
      state.isLoading = false;
    },
    setToggleModal: (state, action) => {
      state.toggleModal = !state.toggleModal;
    },
    setCustomerToolMappingData: (state, action) => {
      state.customerToolMapping = action.payload;
      state.isLoading = false;
    },

    setResetAlert: () => {
      return initialState;
    },
  },
});

export const {
  start,
  setReducerError,
  setAllAlertingToolPolicies,
  setAllAlertingTools,
  setToolMappingData,
  setToolProjectsData,
  getAllToolInfo,
  setToolFields,
  setResetAlert,
  setCompanyServicesList,
  setToggleModal,
  setCustomerToolMappingData,
} = AlertPolicySlice.actions;

export default AlertPolicySlice.reducer;
